import getSubdomainFromUrl from '../../getSubdomainFromUrl';
import { getChannel } from '../../getChannel';

export const NHS_PRIVACY_URL =
  'https://cdn.unmind.com/CMS/unmindApp/assets/termsOfUse/Unmind_PrivacyPolicy_NHS.pdf';

export default () =>
  getSubdomainFromUrl() === 'nhs' ? NHS_PRIVACY_URL : getChannel().privacyUrl;
